import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';

@Component({
  selector: 'app-invoice-detail',
  templateUrl: './invoice-detail.page.html',
  styleUrls: ['./invoice-detail.page.scss'],
})
export class InvoiceDetailPage implements OnInit {
  fields: any = [];
  public id: string;
  public config: any;

  constructor(
    private route: ActivatedRoute,
    public languageService: LanguagesService,
    private remoteConfig: RemoteConfigService) {

  }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.remoteConfig.getSettingsInvoicesConfig().subscribe((data: any) => {
      this.fields = (data && data['fields']) ? data['fields'] : false;
      this.config = {
        imageField: 'image',
        fields: this.fields
      };
    });
  }

  get getTextsIUPageInvoices() {
    return this.languageService.textsIU.page_invoices_detail;
  }
}
